import { Grid, styledComponent, Button, Tabs, Pagination, Link } from '@hermes/web-components'

export const SitemapContainer = styledComponent(Grid)(({ theme }) => ({
  padding: '112px 54px 30px 54px',
  minHeight: '100vh',
  gap: '30px',
  backgroundColor: theme.palette.common.white,
  [theme.breakpoints.down('sm')]: {
    gap: '24px',
    padding: '96px 16px 24px 16px'
  }
}))

export const NavigationsContainer = styledComponent(Grid)({
  gap: '8px',
  flexWrap: 'nowrap',
  overflowX: 'auto',
  maxWidth: '100%'
})

export const NavigationTab = styledComponent(Button, {
  shouldForwardProp: (prop) => prop !== 'active'
})<{ active?: boolean; component?: typeof Link }>(({ theme, active }) => ({
  border: `1px solid ${theme.palette.blue[active ? 400 : 200]} !important`,
  background: `${active ? theme.palette.blue[200] : theme.palette.common.white} !important`,
  color: `${theme.palette.system.navy900} !important`,
  borderRadius: '50px',
  padding: '6px 16px',
  transition: 'all 0.3s',
  fontSize: '13px',
  lineHeight: '20px',
  fontWeight: active ? 500 : 400,
  outline: 'none !important',
  flexShrink: 0,
  '@media (hover: hover)': {
    '&:hover, &:active': {
      border: `1px solid ${theme.palette.blue[400]} !important`,
      background: `${theme.palette.blue[200]} !important`
    }
  }
}))

export const SortingTabs = styledComponent(Tabs)(({ theme }) => ({
  maxWidth: '100%',
  borderTop: `1px solid ${theme.palette.blue[200]}`,
  borderBottom: `1px solid ${theme.palette.blue[200]}`,
  backgroundColor: 'transparent',
  '.MuiTabs-flexContainer': {
    justifyContent: 'space-between'
  },
  '.MuiTabs-indicator': {
    backgroundColor: theme.palette.system.navy900,
    borderRadius: '2px'
  },
  '.MuiTab-root': {
    '&.Mui-selected': {
      fontWeight: 600
    },
    minWidth: '36px',
    padding: 0,
    a: {
      width: '100%',
      lineHeight: '58px',
      fontSize: '15px',
      textDecoration: 'none',
      textTransform: 'uppercase',
      color: theme.palette.text.primary
    },
    '&:after': {
      background: 'transparent !important'
    },
    '@media (hover: hover)': {
      '&:hover': {
        fontWeight: 600
      }
    }
  }
}))

export const SitemapItem = styledComponent(Grid)(({ theme }) => ({
  minHeight: '55px',
  height: '100%',
  width: '90%',
  [theme.breakpoints.down('sm')]: {
    width: '100%'
  },
  a: {
    width: 'inherit',
    fontSize: '13px',
    display: 'block',
    color: theme.palette.text.primary,
    textDecoration: 'none',
    '@media (hover: hover)': {
      '&:hover': {
        textDecoration: 'underline'
      }
    }
  }
}))

export const SitemapPagination = styledComponent(Pagination)(({ theme }) => ({
  '.MuiPaginationItem-root': {
    fontSize: '14px',
    fontWeight: 500,
    '&.Mui-disabled': {
      opacity: 1
    },
    '&.Mui-selected': {
      border: `1px solid ${theme.palette.blue[200]}`,
      backgroundColor: `${theme.palette.text.darkNavy900} !important`,
      color: theme.palette.common.white
    }
  },
  '.MuiPagination-ul': {
    flexWrap: 'nowrap',
    'li > a': {
      textDecoration: 'none'
    }
  }
}))
